import {gsap} from "gsap";

import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('.pdw-aos').forEach((el) => {
        gsap.to(el, {
            scrollTrigger: {
                trigger: el,
                start: "top center",
                end: "top 100px",
                scrub: 3,
                markers: false
            },
            scale: 1.1,
            ease: "none",
            duration: 2
        });
    });
});